import { useParams } from "react-router";

import { DataError, LoadingIndicator, Table } from "@digital-services/ui";

// import { getRandomAppRolesArray } from "../../mocks/app-roles.gen";
import { useGetAppRoles } from "../../services/use-get-app-roles";
import { AddApplicationRolesButton } from "../AddApplicationRolesButton";
import { NoAppRolesConfigured } from "../NoAppRolesConfigured";
import { AppRoleDataRow } from "./AppRoleDataRow";
import { AppRolesHeaderRow } from "./AppRolesHeaderRow";

export const ApplicationRolesTable = () => {
  const { apiUserId } = useParams();

  const { appRoles, isLoading, error } = useGetAppRoles();
  // const appRoles = getRandomAppRolesArray();

  if (isLoading) {
    return (
      <div className="flex w-full items-center text-base">
        <LoadingIndicator label={"Loading Application roles"} />
      </div>
    );
  }

  if (error) {
    return (
      <DataError
        title={"Error loading Application roles"}
        message=""
        className="text-left! text-red-600"
      />
    );
  }

  if (!appRoles?.length) {
    return <NoAppRolesConfigured />;
  }

  return (
    <>
      <div className="mb-3 flex items-center justify-end gap-3">
        <div className="grow"></div>
        {false ? <AddApplicationRolesButton apiUserId={apiUserId} /> : null}
      </div>

      <div data-testid="application-roles-table">
        <Table className="w-full" rowHoverHighlight>
          <thead>
            <AppRolesHeaderRow />
          </thead>
          <tbody>
            {appRoles.map((item, index) => (
              <AppRoleDataRow key={`row-key-${index}`} data={item} />
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};
